import { arrayToMap } from "@entrilia/shared/utilities/arrayHelper";
import type { FundInvestorContact, InvestorPortalRoleWithNoneValue } from "../../../../api/types/investorContactsTypes";

export interface ContactSummary {
  name: string;
  email?: string;
  isCurrentUser: boolean;
}

export interface ContactFilterOption {
  contactId: string;
  name: string;
  email?: string;
}

export interface ContactsFilterState {
  fundIds: string[];
  contactIds: string[];
  role: InvestorPortalRoleWithNoneValue | "";
  search: string;
}

export const getInitialContactsFilterState = (): ContactsFilterState => ({
  fundIds: [],
  contactIds: [],
  role: "",
  search: "",
});

export const getContactsById = (rows: FundInvestorContact[]): Map<string, ContactSummary> =>
  arrayToMap(
    rows,
    (row) => row.contactId,
    (row) => ({ name: row.contactName, email: row.contactEmail, isCurrentUser: row.isCurrentUser })
  );

export const filterContactRows = (rows: FundInvestorContact[], filters: ContactsFilterState): FundInvestorContact[] =>
  rows.filter((row) => {
    const matchesSearch =
      !filters.search ||
      row.fundName.toLowerCase().includes(filters.search) ||
      row.contactName.toLowerCase().includes(filters.search) ||
      !!row.contactEmail?.toLowerCase().includes(filters.search);
    const matchesFund = filters.fundIds.length === 0 || filters.fundIds.includes(row.fundId);
    const matchesContact = filters.contactIds.length === 0 || filters.contactIds.includes(row.contactId);
    const matchesRole = filters.role === "" || (filters.role === "None" ? !row.role : row.role === filters.role);

    return matchesSearch && matchesFund && matchesContact && matchesRole;
  });
